<template>
  <div v-if="!can('Payment Activity', 'no access')">
   <fieldset :disabled="!can('Payment Activity', 'manage')">
      <div v-for="(item, idx) in items" :key="idx">
        <ShipmentPrototypeItem
          :visible="item.flag"
          :expanded="false"
          :collapsible="false"
          :key="item.id"
          :id="item.id"
          @delete="removeItem"
          @toggleHazard="toggleHazardous(idx)"
        >
          <template v-slot:title>
            <b-input-group>
              <b-form-datepicker
                v-model="item.paidDate"
                :min="new Date()"
                class="normalize text-center"
              ></b-form-datepicker>
              <b-form-select
                  v-model="item.paymentMethod"
                  :options="paymentMethod"
                  class="text-center"
              ></b-form-select>
              <b-form-input
                aria-label="Amount"
                placeholder="Amount"
                class="col-3 text-center"
                type="number"
                step="0.01"
                min="0"
                v-model.number="item.amount"
                number
              ></b-form-input>
            </b-input-group>
          </template>
        </ShipmentPrototypeItem>
      </div>
      <hr class="my-0">
      <b-button
        variant="outline-dark"
        class="mt-3 text-xs"
        @click="addNewItem()"
      >
        Add Payment
      </b-button>
    </fieldset>
  </div>
</template>

<script>
import ShipmentPrototypeItem from './ShipmentPrototypeItem.vue';

export default {
  name: 'ShipmentPrototypePaymentList',
  props: ['items'],
  data() {
    return {
      paymentMethod: [
        { value: null, text: 'Payment Method' },
        { value: 'card', text: 'Credit Card' },
        { value: 'cash', text: 'Cash' },
        { value: 'check', text: 'Check' },
        { value: 'Zelle', text: 'Zelle' },
      ],
    };
  },
  methods: {
    removeItem(id) {
      this.$emit('remove', id);
    },
    addNewItem() {
      this.$emit('add');
    },
    toggleHazardous(idx) {
      this.$emit('toggleHazard', idx);
    },
  },
  components: { ShipmentPrototypeItem },
};
</script>

<style scoped>

</style>
